<ion-content class="bg-color ion-content update-user">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.url; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <span class="org-header">API Settings</span>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <form [formGroup]='editApi_settingform'>
                <div class="form-layout">
                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Enter Name</mat-label>
                    <input matInput type="text" formControlName="name" placeholder="Enter Name" required>
                  </mat-form-field>
  
                  <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Type</mat-label>
                    <mat-select formControlName="type" required>
                      <mat-option *ngFor="let type of api_types" [value]="type">{{type}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
  
                <div class="form-row">
                  <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <textarea matInput placeholder="Enter Description" formControlName="description"></textarea>
                  </mat-form-field>
                </div>
                <div class="form-row-1">
                  <mat-form-field appearance="outline">
                    <mat-label>Duration</mat-label>
                    <mat-select formControlName="secret_expiry" required>
                      <mat-option *ngFor="let duration of valid_duration" [value]="duration.value">{{duration.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="key-section">
                  <div>
                    <mat-label>Client ID *</mat-label>
                    <div class="client_secret_container">
                      <div class="custom-mat-form-field" tabindex="0" contenteditable="false" id="client-id">
                        <div class="icon">
                          <mat-icon class="copy-icon" matSuffix color="primary"
                            (click)="copyContent(editApi_settingform.get('client_id').value, 'client_id')"
                            [matTooltip]="client_id_copied ? 'Copied' : 'Copy'">{{client_id_copied ? 'check' :
                            'content_copy'}}</mat-icon>
                          <mat-icon class="visibility-icon" matSuffix color="primary"
                            (click)="isClientIdVisible=!isClientIdVisible">{{isClientIdVisible ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                        </div>
                        <span>{{isClientIdVisible ? client_id_password : editApi_settingform.value['client_id']}}</span>
                      </div>
                    </div>
                  </div>
                
                  <div>
                    <mat-label>Client Secret *</mat-label>
                    <div class="client_secret_container">
                      <div class="custom-mat-form-field" tabindex="0" contenteditable="false" id="client_secret">
                        <div class="icon">
                          <mat-icon class="copy-icon" matSuffix color="primary"
                            (click)="copyContent(editApi_settingform.get('client_secret').value, 'client_secret')"
                            [matTooltip]="client_secret_copied ? 'Copied' : 'Copy'">{{client_secret_copied ? 'check' :
                            'content_copy'}}</mat-icon>
                          <mat-icon class="visibility-icon" matSuffix color="primary"
                            (click)="isClientSecretVisible=!isClientSecretVisible">{{isClientSecretVisible ? 'visibility_off' :
                            'visibility'}}</mat-icon>
                        </div>
                        <span>{{isClientSecretVisible ? client_secret_password : editApi_settingform.value['client_secret']}}</span>
                      </div>
                    
                      <div class="refresh-btn" *ngIf="!view_page">
                        <mat-icon color="primary" (click)="createClientSecret()">refresh</mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
             <div class="btn-signup-grid">
                  <button mat-button mat-dialog-close class="btn btn-cancel" routerLink="/baseapp/profile/api-settings">{{view_page?'Back':'Cancel'}}</button>
                  <button type="submit" class="btn btn-save" (click)="updateClientSecret()" *ngIf="!view_page">Update</button>
                </div>
              </form>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- <app-about-page *ngIf="hide1200"></app-about-page> -->
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>











